import { useCallback, useState } from "react";

/**
 * Copies a URL to the clipboard with a brief "copied" feedback state.
 * Falls back to `window.prompt` when clipboard API is unavailable.
 */
export const useCopyLink = (resetMs = 2000) => {
  const [copied, setCopied] = useState(false);

  const copyLink = useCallback(
    async (url: string, fallbackPrompt?: string) => {
      if (!url) return false;
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        window.setTimeout(() => setCopied(false), resetMs);
        return true;
      } catch {
        if (fallbackPrompt) {
          window.prompt(fallbackPrompt, url);
        }
        return false;
      }
    },
    [resetMs]
  );

  return { copied, copyLink };
};
